export default __webpack_public_path__ + "static/media/5065.ed38c65d.png";